import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import {
  cash,
  success,
  vector,
} from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { Margin, usePDF } from 'react-to-pdf';
import DownloadPdf from "../../Component/DownloadPdf";
import moment from "moment";
import { Toast } from "../../Component/Toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CustomScroll from "../../Component/CustomScroll";

const DrawReport = () => {


  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);
  const [popup2, setPopup2] = useState(false);



  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [showMessage, setShowMessage] = useState('')
  const location = useLocation();
  const listData = location.state?.listData;
  const slotId = location.state?.slotId;
  const lot_name = location.state?.lot_name;
  const time = location.state?.time;
  const date = location.state?.date;
  const hasDeclareData = location.state?.hasDeclare;

  const [showSuccess, setShowSuccess] = useState(hasDeclareData ?? false);
  const [downSuccess, setDownSuccess] = useState(false);


//   console.log("listData", listData);
  const [list, setList] = useState(listData || []);

  const fetchList = async () => {
    // setLoader(true);
    const res = await get(`${URLS.DRAWREPORT}?game_slot_id=${slotId}`);
//     console.log("Fetched data:", res);
    const hasDeclare = res?.result_declared
    if (hasDeclare) {
      setShowSuccess(true);
    }

    if (res?.status === "success") {
      setList(res);
    }
    // setLoader(false);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("pageReloaded", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  useEffect(() => {
    const wasReloaded = sessionStorage.getItem("pageReloaded");

    if (wasReloaded === "true") {
      fetchList();
      sessionStorage.removeItem("pageReloaded"); // important
    }
  }, []);

  const filteredData = list?.data?.filter(
    item => item?.paid?.toLowerCase() === "paid"
  );


  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Lot Details",
        accessor: "lot_name",
        Cell: ({ value }) => {
          const text = value || "";

          const lower = text.toLowerCase();
          let index = -1;

          if (lower.includes("dear")) {
            index = lower.indexOf("dear");
          } else if (lower.includes("kerala")) {
            index = lower.indexOf("kerala");
          }

          let firstLine = text;
          let secondLine = "";

          if (index !== -1) {
            firstLine = text.substring(0, index).trim();
            secondLine = text.substring(index).trim();
          }

          return (
            <div>
              <p>{firstLine}</p>
              {secondLine && <p>{secondLine}</p>}
            </div>
          );
        },
      },
      {
        Header: "Prize Detail",
        accessor: "digit",
        Cell: ({ value }) => {
          if (!value) return null;

          // Remove extra spaces

          return (
            <div style={{ width: 200 }}>
              <p>{value}</p>
            </div>
          );
        },
      },
      {
        Header: "Prize No",
        accessor: "selected_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Qty",
        accessor: "qty",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Prize Amount",
        accessor: "total",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Result Status",
        accessor: "paid",
        Cell: ({ value, row }) => {

          const painedStatus = row.original.winning_result?.status;

          return (
            <div className="d-flex ac-jc">
              <button

                className={`${value === "Paid" ? "paid" : "not_paid"
                  } border-0 fs-sm-10 f2 fs-md-12 fs-lg-14 fs-xl-13`}
              >
                {value}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const handleResultDeclare = async () => {
    setLoading1(true);

    const res = await post(URLS?.DECLAREPOST, { game_slot_id: slotId });
//     console.log("res declare", res);

    if (res?.status === "success") {
      setLoading1(false);
      // Toast(res?.message || "Announced Successfully");
      fetchList();
      setShowMessage(res?.message);
      setPopup2(true);
      setPopup(false);
    } else {
      setLoading1(false);
      setPopup(false);
    }
  }


  const generatePdf = (rows) => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();

    const cleanedRows = rows.map(r => {
      let lot_name = r?.lot_name;

      if (typeof lot_name === "string") {
        lot_name = lot_name
          .replace(/(dear|kerala)[\s\S]*$/i, "") // REMOVE DEAR/KERALA + AFTER
          .trim();
      }

      return {
        ...r,
        lot_name,
      };
    }).filter(r => r.lot_name);

//     console.log('new data filter', cleanedRows)
    const finalRows = cleanedRows.length ? cleanedRows : rows;

    // ---- HEADER TEXT ----
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text("Winner Agency – Draw Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Date: ${moment(date).format("DD-MM-YYYY")}  |  Lot: ${lot_name}  |  Time: ${time}`,
      pageWidth / 2,
      22,
      { align: "center" }
    );

    doc.text(
      `Report Generated on: ${moment(new Date()).format("DD-MM-YYYY hh:mm a")}`,
      pageWidth / 2,
      28,
      { align: "center" }
    );

    // ---- DIVIDER LINE ----
    doc.setLineWidth(0.5);
    doc.line(10, 32, pageWidth - 10, 32);

    // ---- TABLE ----
    autoTable(doc, {
      startY: 36, // IMPORTANT: start after header
      head: [["Time", "Mobile No", "Prize Detail", "Prize No", "Qty", "Prize Amount", "Result Status"]],
      body: finalRows.map((r) => [
        r.time,
        r.mobile,
        r.digit,
        r.selected_number,
        r.qty,
        r.total,
        r.paid
      ]),
      foot: [[
        {
          content: "Total Prize",
          colSpan: 5,
          styles: { halign: "right" }
        },
        {
          content: `Rs. ${list?.total_prize_amount ?? 0}`,
          colSpan: 4,
          styles: { halign: "left" }
        }
      ]],
      showFoot: "lastPage",
      styles: {
        fontStyle: "bold",
        textColor: 'black',
        fontSize: 10,
        cellPadding: 1,
        overflow: "linebreak",
        lineWidth: 0.1,
        lineColor: [200, 200, 200]
      },
      headStyles: {
        fillColor: [0, 71, 67],
        textColor: 255,
        lineWidth: 0.5,       // Header border thicker
        valign: "middle",
        halign: "center",
        fontSize: 11
      },
      footStyles: {
        fontSize: 12,
        fontStyle: "bold",
        halign: "left",
        fillColor: [246, 220, 181]
      },
      margin: 5,
    });

    doc.save(`winnerdrawreport_${moment(date).format("DD-MM-YYYY")}_${time}.pdf`);
  };


  const handleDownload = async () => {

    if (!list?.data?.length) {
      Toast("No data available to download");
      return;
    }

    try {
      setLoading(true);
      await generatePdf(list?.data);
      setDownSuccess(true);
    } catch (error) {
      console.error(error);
      Toast("Failed to download PDF");
    } finally {
      setLoading(false);
    }
  };

  const [browsHeader, setBrowsHeader] = useState(true);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);
      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);

  return (
    <div style={{
      // marginBottom: browsHeader ? 75 : 42,
      // paddingBottom: browsHeader ? 94 : 45
    }} className="dashRightView marginScrolls d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div className="container_overalls">
          <div style={{ marginRight: 22, marginLeft: 22, marginBottom: 20 }} className="d-flex ac-jb ">

            {!showSuccess ? (
              <img
                src={cash}
                onClick={() => setPopup(true)}
                height={30}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <img src={success} height={20} />
            )}


            <div className="d-flex ac-je my-2">
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  style={{ color: "#004743", width: 12, height: 12 }}
                />
              ) : downSuccess ? (
                <img src={success} height={20} />
              ) : (
                <img onClick={handleDownload} src={vector} height={15} />
              )}
            </div>

          </div>
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={list?.data}
            show={false}
          />
        </div>

        {popup2 && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                {showMessage}
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-je px-2 f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button
                  onClick={() => {
                    setPopup2(false);
                    setShowSuccess(true);
                  }}
                  className="yes-btn w-40"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )}

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Approve?
              </p>
              <div
                style={{ paddingTop: 20 }}
                className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleResultDeclare}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  ) : (
                    "Yes"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

      </CustomScroll>
      <div className="d-flex ac-jb px-4 team_size">
        <p className="f4 fs-xs-13 fs-sm-14 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-17  white">
          Total Prize
        </p>
        <p className="f4 fs-xs-13 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-17 white ">
          {`₹ ${list?.total_prize_amount || 0}`}
        </p>
      </div>
    </div>
  );
};

export default DrawReport;
